exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2PoNW1nSf04k_Y2bDu1v0s{display:inline-block;padding:20px}._2izQ8K2b91GeQp_6fOcmKq{height:100px;text-align:center}._1-Ee5esny1J1Fxozk6papg{display:inline-block;float:left}._1-Ee5esny1J1Fxozk6papg img{max-width:100%}._3EUErkpTfnm0alVyDLvfz{display:flex;justify-content:center}._3EUErkpTfnm0alVyDLvfz>a:first-child{padding-right:20px}\n", ""]);

// Exports
exports.locals = {
	"children": "_2PoNW1nSf04k_Y2bDu1v0s",
	"empty": "_2izQ8K2b91GeQp_6fOcmKq",
	"contents": "_1-Ee5esny1J1Fxozk6papg",
	"actions": "_3EUErkpTfnm0alVyDLvfz"
};